import { apiRequest, refreshSession, setAccessToken } from './client';

export interface CurrentUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string | null;
  role: 'ADMIN' | 'DRIVER' | 'DISPATCHER' | 'SERVICE';
}

interface AuthResponse {
  user: CurrentUser;
  accessToken: string;
}

export const login = async (email: string, password: string): Promise<CurrentUser> => {
  const result = await apiRequest<AuthResponse>('/auth/login', {
    method: 'POST',
    body: { email, password }
  });

  setAccessToken(result.accessToken);
  return result.user;
};

export const restoreSession = async (): Promise<CurrentUser | null> => {
  const result = await refreshSession<CurrentUser>();
  return result?.user ?? null;
};

export const logout = async (): Promise<void> => {
  try {
    await apiRequest<void>('/auth/logout', { method: 'POST', skipAuthRetry: true });
  } finally {
    setAccessToken(null);
  }
};

export const fetchCurrentUser = async (): Promise<CurrentUser> => {
  const result = await apiRequest<{ user: CurrentUser }>('/auth/me');
  return result.user;
};
